import { useEffect, cloneElement } from "react";
import { useClearHomeLastScrollY, useHomeLastScrollY, useSetHomeLastScrollY } from "@hooks/use-home-navigation-hooks";

const HomeScrollY = ({
  children,
  ...other
}) => {
  const lastScrollY = useHomeLastScrollY();
  const setLastScrollY = useSetHomeLastScrollY();
  const clearLastScrollY = useClearHomeLastScrollY();

  const scrollToLastPosition = () => {
    setTimeout(() => {
      window.scrollTo({ top: lastScrollY, behaviour: "smooth" });
      clearLastScrollY();
    }, 0);
  };

  const handleLastScrollY = () => {
    const { scrollY } = window;

    setLastScrollY(scrollY);
  };

  useEffect(() => {
    scrollToLastPosition();

    window.addEventListener("scroll", handleLastScrollY);

    return () => window.removeEventListener("scroll", handleLastScrollY);
  }, []);

  return cloneElement(children, other);
};

export default HomeScrollY;
